module.exports = __webpack_public_path__ + "static/media/hashtags-screenshot-a-small.196cc5d0.png";